/* [04] Field Camp: souvenir selfie + printed 10x15 cm postcard. Self-contained (injects CSS + DOM).
   Photo stays in memory only: it is printed and then dropped, never stored or sent.
   Kiosk Chrome flags: --kiosk --kiosk-printing --use-fake-ui-for-media-stream (printer = default printer, 10x15 paper) */
(()=>{
if(window.__selfie04)return;window.__selfie04=1;
const $=s=>document.querySelector(s);
const lang=()=>(document.documentElement.lang==='en'?'en':'it');
const TX={
 it:{pill:'Foto ricordo',title:'Foto ricordo',exit:'Chiudi',btn:'Foto ricordo',
  introH:'Una cartolina per te.',introP:'Ti facciamo una foto e te la stampiamo su una cartolina 10x15 di Field Camp. La foto non viene salvata e non viene inviata: esiste solo sulla cartolina che ritiri.',
  go:'Scatta',consent:'Ok, scatta la foto',cam:'Inquadrati e sorridi.',countA:'Tre secondi',
  revH:'Ti piace?',print:'Stampa la cartolina',retake:'Rifai',
  printing:'Stampa in corso',printingP:'Ritira la cartolina allo slot qui sotto. Ci vogliono pochi secondi.',doneBtn:'Fatto',
  noCam:'Non riesco ad accedere alla fotocamera. Chiedi aiuto allo staff.',
  seen:'Visto a Field Camp',run:'Moss Run',leaves:'foglie'},
 en:{pill:'Souvenir photo',title:'Souvenir photo',exit:'Close',btn:'Souvenir photo',
  introH:'A postcard for you.',introP:'We take your photo and print it on a 10x15 Field Camp postcard. The photo is not saved and not sent anywhere: it only exists on the postcard you take with you.',
  go:'Take photo',consent:'Ok, take the photo',cam:'Frame yourself and smile.',countA:'Three seconds',
  revH:'Like it?',print:'Print the postcard',retake:'Retake',
  printing:'Printing',printingP:'Pick up your postcard at the slot below. It takes a few seconds.',doneBtn:'Done',
  noCam:'I cannot reach the camera. Ask the staff for help.',
  seen:'Seen at Field Camp',run:'Moss Run',leaves:'leaves'}
};
const t=k=>TX[lang()][k];

const css=document.createElement('style');
css.textContent=`
#sf{position:fixed;inset:0;z-index:55;background:#fff;color:#030302;display:grid;grid-template-rows:auto 1fr;font-family:var(--f-ui,"Inter Tight",Archivo,Helvetica,Arial,sans-serif)}
#sf[hidden]{display:none!important}
#sf .sf-top{height:72px;padding:0 20px;display:flex;align-items:center;gap:14px;border-bottom:1px solid #d9d6cf;background:#fff;position:relative;z-index:2}
#sf .sf-logo{font-weight:700;font-size:24px;letter-spacing:-.04em;line-height:1}
#sf .sf-logo sup{font-size:.42em;letter-spacing:0;margin-left:1px;vertical-align:top;position:relative;top:.1em}
#sf .sf-ttl{margin-left:auto;font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#61703a}
#sf .sf-x{min-height:44px;padding:0 18px;border:1px solid #d9d6cf;border-radius:999px;font:700 12px/1 inherit;font-family:inherit;letter-spacing:.06em;text-transform:uppercase;background:none;cursor:pointer;color:inherit}
#sf .sf-main{position:relative;overflow:hidden;display:grid;place-items:center;padding:16px}
#sf .sf-view{display:grid;gap:18px;justify-items:center;width:100%}
#sf .sf-view[hidden]{display:none!important}
#sf .sf-card{background:#fff;padding:clamp(24px,4vw,44px);width:min(620px,100%);display:grid;gap:20px;justify-items:start;border:1px solid #d9d6cf}
#sf .sf-card h2{font-weight:700;font-size:clamp(34px,6vw,64px);letter-spacing:-.04em;line-height:.98;text-wrap:balance}
#sf .sf-card p{font-size:clamp(16px,1.8vw,19px);max-width:46ch}
#sf .sf-lbl{font-size:11px;font-weight:700;letter-spacing:.08em;text-transform:uppercase;color:#6f6c66}
#sf .sf-btns{display:flex;gap:10px;flex-wrap:wrap}
#sf .sf-btn{min-height:60px;padding:0 30px;border-radius:999px;border:1px solid #030302;background:#fff;color:#030302;font:700 13px/1 inherit;font-family:inherit;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;display:inline-flex;align-items:center;justify-content:center}
#sf .sf-btn.pri{background:#030302;color:#fff}
#sf .sf-btn.moss{background:#808D45;border-color:#808D45;color:#fff}
#sf .sf-vid{position:relative;width:min(92vw,calc((100vh - 260px)*0.75),560px);aspect-ratio:3/4;background:#edebe7;overflow:hidden;border:1px solid #d9d6cf}
#sf video{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;transform:scaleX(-1)}
#sf .sf-cd{position:absolute;inset:0;display:grid;place-items:center;font-size:clamp(120px,30vw,260px);font-weight:700;color:#fff;text-shadow:0 2px 30px rgba(3,3,2,.35);letter-spacing:-.05em}
#sf .sf-flash{position:absolute;inset:0;background:#fff;opacity:0;pointer-events:none}
#sf .sf-flash.on{animation:sfFlash .45s ease-out}
@keyframes sfFlash{0%{opacity:.95}100%{opacity:0}}
#sf .sf-prev{max-height:calc(100vh - 300px);max-width:min(92vw,520px);width:auto;height:auto;border:1px solid #d9d6cf;box-shadow:0 6px 30px rgba(3,3,2,.12);background:#edebe7}
#sf .sf-hint{font-size:15px;color:#6f6c66}
@media(max-width:599px){#sf .sf-top{height:60px;padding:0 12px}#sf .sf-logo{font-size:18px}}
#sfPill{}
#sf .sf-fan{position:relative;width:min(620px,100%);height:clamp(220px,34vh,380px);margin-bottom:-6px}
#sf .sf-pc{position:absolute;left:50%;top:6%;width:min(46%,30vh);aspect-ratio:1;overflow:hidden;border:6px solid #a8ae94;border-radius:4px;background:#252a20 center/cover no-repeat;color:#fff;box-shadow:0 10px 30px rgba(23,32,18,.3);transform:translate(-50%,40%) rotate(8deg);opacity:0;transition:transform 1s cubic-bezier(.2,.8,.2,1),opacity .5s ease}
#sf .sf-pc::before{content:'';position:absolute;inset:0;z-index:2;outline:1.5px dashed rgba(255,255,255,.7);outline-offset:-6px;border-radius:2px;pointer-events:none;background:linear-gradient(115deg,rgba(82,105,54,.15),rgba(125,128,92,.1) 45%,rgba(74,96,62,.15)),radial-gradient(ellipse 34% 18% at 0% 0%,rgba(82,105,54,.5),transparent 100%),radial-gradient(ellipse 17% 34% at 100% 28%,rgba(102,115,69,.38),transparent 100%),radial-gradient(ellipse 36% 17% at 100% 100%,rgba(74,96,62,.44),transparent 100%),radial-gradient(ellipse 14% 29% at 0% 78%,rgba(125,128,92,.32),transparent 100%)}
#sf .sf-pc::after{content:'';position:absolute;inset:0;z-index:1;background:linear-gradient(transparent 60%,rgba(0,0,0,.55));pointer-events:none}
#sf .sf-pc b{position:absolute;z-index:3;left:12px;bottom:10px;font-weight:400;font-size:clamp(12px,1.6vw,16px)}
#sf .sf-fan.on .sf-pc{opacity:1}
#sf .sf-fan.on .p0{transform:translate(-50%,0) rotate(-4deg);z-index:3}
#sf .sf-fan.on .p1{transform:translate(-92%,8%) rotate(-12deg);transition-delay:.15s;z-index:2}
#sf .sf-fan.on .p2{transform:translate(-8%,6%) rotate(9deg);transition-delay:.3s;z-index:1}
`;
document.head.appendChild(css);

const root=document.createElement('div');root.id='sf';root.hidden=true;root.setAttribute('role','dialog');root.setAttribute('aria-modal','true');
root.innerHTML=`<div class="sf-top"><div class="sf-logo">[04]-STUDIOS<sup>™</sup></div><span class="sf-ttl" id="sfTtl"></span><button class="sf-x" id="sfX"></button></div>
<div class="sf-main">
 <div class="sf-view" id="sfIntro"><div class="sf-fan" id="sfFan"></div><div class="sf-card"><span class="sf-lbl">Field Camp</span><h2 id="sfIh"></h2><p id="sfIp"></p><div class="sf-btns"><button class="sf-btn pri" id="sfGo"></button></div></div></div>
 <div class="sf-view" id="sfCam" hidden><div class="sf-vid"><video id="sfVideo" playsinline muted autoplay></video><div class="sf-cd" id="sfCd"></div><div class="sf-flash" id="sfFlash"></div></div><p class="sf-hint" id="sfCamH"></p></div>
 <div class="sf-view" id="sfRev" hidden><canvas class="sf-prev" id="sfPrev"></canvas><div class="sf-btns"><button class="sf-btn pri" id="sfPrint"></button><button class="sf-btn" id="sfRetake"></button></div></div>
 <div class="sf-view" id="sfDone" hidden><div class="sf-card"><span class="sf-lbl">Field Camp</span><h2 id="sfDh"></h2><p id="sfDp"></p><div class="sf-btns"><button class="sf-btn moss" id="sfOk"></button></div></div></div>
 <div class="sf-view" id="sfErr" hidden><div class="sf-card"><h2 id="sfEh"></h2><div class="sf-btns"><button class="sf-btn pri" id="sfEx"></button></div></div></div>
</div>`;
document.body.appendChild(root);

let stream=null,photo=null,ctxInfo=null,idleT=0,cdT=0,doneT=0,mossHost=null;
const view=v=>['Intro','Cam','Rev','Done','Err'].forEach(n=>{$('#sf'+n).hidden=n!==v});
function labels(){
  $('#sfTtl').textContent=t('title');$('#sfX').textContent=t('exit');
  $('#sfIh').textContent=t('introH');$('#sfIp').textContent=t('introP');$('#sfGo').textContent=t('consent');
  $('#sfCamH').textContent=t('cam');$('#sfPrint').textContent=t('print');$('#sfRetake').textContent=t('retake');
  $('#sfDh').textContent=t('printing');$('#sfDp').textContent=t('printingP');$('#sfOk').textContent=t('doneBtn');
  $('#sfEh').textContent=t('noCam');$('#sfEx').textContent=t('exit');
  const p=$('#sfPill');if(p)p.textContent=t('pill');
  document.querySelectorAll('.sf-endbtn').forEach(b=>b.textContent=t('btn'));
}
function armIdle(){clearTimeout(idleT);idleT=setTimeout(close,45000)}
function stopCam(){if(stream){stream.getTracks().forEach(x=>x.stop());stream=null}const v=$('#sfVideo');if(v)v.srcObject=null}
function wipe(){photo=null;const c=$('#sfPrev');if(c){c.width=1;c.height=1}}
function close(){
  clearTimeout(idleT);clearTimeout(cdT);clearTimeout(doneT);stopCam();wipe();
  root.hidden=true;
}
/* the same patch mockup as the FOTO RICORDO slide: three [04] patches fanned out, with the model */
const FAN=(()=>{let KD={};try{KD=JSON.parse(document.getElementById('kiosk-data').textContent||'{}')}catch(e){}
  const w=u=>u+(u.indexOf('?')>-1?'&':'?')+'width=900',a=(Array.isArray(KD.heroes)?KD.heroes:[]).map(w);
  (Array.isArray(KD.products)?KD.products:[]).forEach(p=>{const u=p&&p.img&&(p.img[1]||p.img[0]);if(u&&a.length<3)a.push(u)});
  return a.slice(0,3)})();
function fan(){
  const f=$('#sfFan');if(!f)return;if(!FAN.length){f.hidden=true;return}
  f.classList.remove('on');
  f.innerHTML=FAN.map((u,i)=>'<div class="sf-pc p'+i+'" style="background-image:url(&quot;'+u+'&quot;)"><b></b></div>').join('');
  f.querySelectorAll('b').forEach(b=>b.textContent=t('seen'));
  requestAnimationFrame(()=>requestAnimationFrame(()=>f.classList.add('on')));
}
function open(info){ctxInfo=info||null;root.hidden=false;view('Intro');labels();fan();armIdle()}

async function startCam(){
  armIdle();
  try{
    stream=await navigator.mediaDevices.getUserMedia({video:{facingMode:'user',width:{ideal:1920},height:{ideal:1440}},audio:false});
  }catch(e){view('Err');return}
  const v=$('#sfVideo');v.srcObject=stream;
  try{await v.play()}catch(e){}
  view('Cam');countdown(3);
}
function countdown(n){
  const cd=$('#sfCd');
  if(n<=0){cd.textContent='';snap();return}
  cd.textContent=n;cdT=setTimeout(()=>countdown(n-1),1000);
}
function snap(){
  const v=$('#sfVideo');
  const fl=$('#sfFlash');fl.classList.remove('on');void fl.offsetWidth;fl.classList.add('on');
  const w=v.videoWidth||1280,h=v.videoHeight||960;
  const c=document.createElement('canvas');c.width=w;c.height=h;
  c.getContext('2d').drawImage(v,0,0,w,h); /* raw frame (not mirrored): the print reads correctly */
  photo=c;stopCam();
  setTimeout(async()=>{await compose();view('Rev');armIdle()},350);
}

/* ---------- postcard 10x15 cm @ 300 dpi, portrait ---------- */
const PW=1181,PH=1772;
async function mossStrip(w,h){
  const e=window.Moss04Engine;if(!e)return null;
  const host=document.createElement('div');host.style.cssText=`position:fixed;left:-99999px;top:0;width:${w}px;height:${h}px`;
  document.body.appendChild(host);
  try{
    e.setSeed(1+Math.floor(Math.random()*9999));
    const L=new e.Layer(host,{lut:e.makeLUT(e.DEF),size:1.3,dir:'up',anchor:'bottom',profile:x=>.7+.3*e.ss(0,1,x)});
    L.build();L.paint(1,1.3);
    const out=document.createElement('canvas');out.width=w;out.height=h;
    out.getContext('2d').drawImage(L.cv,0,0,w,h);
    return out;
  }catch(err){return null}finally{host.remove()}
}
async function compose(){
  try{await document.fonts.load('700 40px "Suisse Int\'l"');await document.fonts.load('400 24px "Suisse Int\'l"')}catch(e){}
  const FF='"Suisse Int\'l",Archivo,Helvetica,Arial,sans-serif';
  const c=document.createElement('canvas');c.width=PW;c.height=PH;const x=c.getContext('2d');
  x.fillStyle='#edebe7';x.fillRect(0,0,PW,PH);
  const M=64;
  /* header */
  x.fillStyle='#030302';x.textBaseline='alphabetic';x.textAlign='left';
  x.font='700 54px '+FF;x.fillText('[04]-STUDIOS',M,M+50);
  const wmk=x.measureText('[04]-STUDIOS').width;x.font='700 22px '+FF;x.fillText('™',M+wmk+4,M+22);
  x.textAlign='right';x.font='700 24px '+FF;x.fillText('FIELD CAMP',PW-M,M+48);
  /* photo, cover-cropped (3:4 frame) */
  const px=M,py=170,pw=PW-2*M,ph=1050;
  /* the photo as an [04] patch (same look as patch-card-04 on the site): sage border, stitched edge, moss-tinted corners, slight tilt */
  /* moss patina for the photo: grows up from the bottom of the patch and fades out, light */
  let pat=null;{const pm=await mossStrip(pw,ph);if(pm){pat=document.createElement('canvas');pat.width=pw;pat.height=ph;const g=pat.getContext('2d');
    g.drawImage(pm,0,0);g.globalCompositeOperation='destination-in';const gr=g.createLinearGradient(0,0,0,ph);
    gr.addColorStop(0,'rgba(0,0,0,.08)');gr.addColorStop(.55,'rgba(0,0,0,.14)');gr.addColorStop(.8,'rgba(0,0,0,.38)');gr.addColorStop(1,'rgba(0,0,0,.62)');g.fillStyle=gr;g.fillRect(0,0,pw,ph)}}
  {const B=22,R=12,cx=px+pw/2,cy=py+ph/2,rr=(X,Y,W,H,r)=>{x.beginPath();if(x.roundRect)x.roundRect(X,Y,W,H,r);else x.rect(X,Y,W,H)};
   x.save();x.translate(cx,cy);x.rotate(-1.4*Math.PI/180);x.translate(-cx,-cy);
   x.save();x.shadowColor='rgba(23,32,18,.28)';x.shadowBlur=26;x.shadowOffsetY=10;x.fillStyle='#a8ae94';rr(px,py,pw,ph,R);x.fill();x.restore();
   const ix=px+B,iy=py+B,iw=pw-2*B,ih=ph-2*B;
   x.save();rr(ix,iy,iw,ih,4);x.clip();x.fillStyle='#252a20';x.fillRect(ix,iy,iw,ih);
   const s=Math.max(iw/photo.width,ih/photo.height),dw=photo.width*s,dh=photo.height*s;
   x.drawImage(photo,ix+(iw-dw)/2,iy+(ih-dh)/2,dw,dh);
   const lg=x.createLinearGradient(ix,iy+ih,ix+iw,iy);lg.addColorStop(0,'rgba(82,105,54,.15)');lg.addColorStop(.45,'rgba(125,128,92,.1)');lg.addColorStop(1,'rgba(74,96,62,.15)');x.fillStyle=lg;x.fillRect(ix,iy,iw,ih);
   const corner=(X,Y,rx,ry,col)=>{x.save();x.translate(X,Y);x.scale(rx,ry);const g=x.createRadialGradient(0,0,0,0,0,1);g.addColorStop(0,col);g.addColorStop(1,'rgba(0,0,0,0)');x.fillStyle=g;x.beginPath();x.arc(0,0,1,0,Math.PI*2);x.fill();x.restore()};
   corner(ix,iy,iw*.34,ih*.18,'rgba(82,105,54,.5)');corner(ix+iw,iy+ih*.28,iw*.17,ih*.34,'rgba(102,115,69,.38)');corner(ix+iw,iy+ih,iw*.36,ih*.17,'rgba(74,96,62,.44)');corner(ix,iy+ih*.78,iw*.14,ih*.29,'rgba(125,128,92,.32)');
   if(pat){x.save();x.globalAlpha=.85;x.drawImage(pat,ix,iy,iw,ih);x.restore()}
   const bg=x.createLinearGradient(0,iy+ih*.6,0,iy+ih);bg.addColorStop(0,'rgba(0,0,0,0)');bg.addColorStop(1,'rgba(0,0,0,.5)');x.fillStyle=bg;x.fillRect(ix,iy+ih*.6,iw,ih*.4);
   x.restore();
   x.save();x.setLineDash([16,10]);x.lineWidth=3;x.strokeStyle='rgba(255,255,255,.72)';rr(ix+6,iy+6,iw-12,ih-12,3);x.stroke();x.restore();
   /* patch label, bottom-left, like the site cards */
   x.fillStyle='#fff';x.textAlign='left';x.font='400 40px '+FF;x.fillText('Field Camp',ix+34,iy+ih-38);
   x.restore()}
  /* moss: rises from the bottom edge up behind the text, light and gradual (no hard band) */
  {const mt=py+ph+6,mh=PH-mt,m=await mossStrip(PW,mh);
   if(m){const f=document.createElement('canvas');f.width=PW;f.height=mh;const g=f.getContext('2d');
     g.drawImage(m,0,0);g.globalCompositeOperation='destination-in';
     const gr=g.createLinearGradient(0,0,0,mh);gr.addColorStop(0,'rgba(0,0,0,0)');gr.addColorStop(.35,'rgba(0,0,0,.12)');gr.addColorStop(.7,'rgba(0,0,0,.38)');gr.addColorStop(1,'rgba(0,0,0,.7)');
     g.fillStyle=gr;g.fillRect(0,0,PW,mh);x.drawImage(f,0,mt)}}
  const I=window.FC04_INFO?window.FC04_INFO():null;
  /* QR, right side of the text zone: Moss Run losers get the €10 [04] credit (code 04CREDIT10, applied by the link), everyone else the site */
  const lost=!!(ctxInfo&&ctxInfo.score!=null&&ctxInfo.target&&ctxInfo.score<ctxInfo.target),en=lang()==='en';
  const qUrl=lost?'https://04-studios.com/discount/04CREDIT10?redirect=%2F':'https://04-studios.com';
  const QS=lost?230:190,qx=PW-M-QS,qy=py+ph+40;
  if(window.qrcode){try{
    const q=qrcode(0,'M');q.addData(qUrl,'Byte');q.make();
    const n=q.getModuleCount(),cs=QS/n;x.fillStyle='#fff';x.fillRect(qx-10,qy-10,QS+20,QS+20);x.fillStyle='#030302';
    for(let r=0;r<n;r++)for(let k=0;k<n;k++)if(q.isDark(r,k))x.fillRect(qx+k*cs,qy+r*cs,Math.ceil(cs),Math.ceil(cs));
    x.textAlign='center';x.font='700 19px '+FF;
    if(lost){x.fillText(en?'€10 FOR YOU · 48H':'€10 PER TE · 48H',qx+QS/2,qy+QS+40);x.font='400 17px '+FF;x.fillText((en?'CODE ':'CODICE ')+'04CREDIT10',qx+QS/2,qy+QS+64)}
    else x.fillText('04-STUDIOS.COM',qx+QS/2,qy+QS+40);
  }catch(e){}}
  /* text zone (always on bone, never over moss) */
  x.textAlign='left';x.fillStyle='#030302';x.font='700 66px '+FF;x.fillText(t('seen'),M,py+ph+92);
  const d=new Date();const pad=n=>String(n).padStart(2,'0');
  const stamp=`${pad(d.getDate())}.${pad(d.getMonth()+1)}.${d.getFullYear()}  ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  x.font='400 28px '+FF;x.fillStyle='#6f6c66';
  let line=stamp;
  if(ctxInfo&&ctxInfo.score!=null&&ctxInfo.target)line+=`   ·   ${t('run')} ${ctxInfo.score}/${ctxInfo.target} ${t('leaves')}`;
  x.fillText(line,M,py+ph+140);
  if(I){x.fillText(I.place+'   '+I.coords,M,py+ph+180);
    x.fillStyle='#030302';x.font='700 34px '+FF;x.fillText(I.morse.split('').join(String.fromCharCode(8202)),M,py+ph+230)}
  x.font='700 24px '+FF;x.fillStyle='#030302';x.fillText('04-STUDIOS.COM',M,py+ph+276);
  /* signature line: [04]-STUDIOS™, Trieste (same type as the site line) */
  {x.save();x.font='400 24px '+FF;x.fillStyle='#fff';x.shadowColor='rgba(3,3,2,.35)';x.shadowBlur=8;x.textAlign='left';
   const y=PH-46,w1=x.measureText('[04]-STUDIOS').width;
   x.fillText('[04]-STUDIOS',M,y);x.font='400 11px '+FF;x.fillText('™',M+w1+2,y-12);
   x.font='400 24px '+FF;x.fillText(', Trieste',M+w1+16,y);x.restore()}
  const pv=$('#sfPrev');pv.width=PW;pv.height=PH;pv.getContext('2d').drawImage(c,0,0);
  photo._post=c;
}

/* ---------- print ---------- */
function doPrint(){
  const post=photo&&photo._post;if(!post)return;
  const url=post.toDataURL('image/jpeg',0.92);
  const fr=document.createElement('iframe');
  fr.style.cssText='position:fixed;right:0;bottom:0;width:0;height:0;border:0;visibility:hidden';
  document.body.appendChild(fr);
  const d=fr.contentDocument;
  d.open();d.write('<!doctype html><html><head><meta charset="utf-8"><title>[04] Field Camp</title><style>@page{size:100mm 150mm;margin:0}html,body{margin:0;padding:0;background:#fff}img{display:block;width:100mm;height:150mm}</style></head><body><img id="p" src="'+url+'"></body></html>');
  d.close();
  const go=()=>{try{fr.contentWindow.focus();fr.contentWindow.print()}catch(e){}setTimeout(()=>fr.remove(),60000)};
  const im=d.getElementById('p');
  if(im.complete)go();else im.onload=go;
  view('Done');clearTimeout(idleT);wipe();
  doneT=setTimeout(close,9000);
}

/* ---------- wiring ---------- */
$('#sfGo').onclick=startCam;
$('#sfX').onclick=close;$('#sfEx').onclick=close;$('#sfOk').onclick=close;
$('#sfRetake').onclick=()=>{wipe();startCam()};
$('#sfPrint').onclick=doPrint;
root.addEventListener('pointerdown',()=>{if(!$('#sfCam').hidden)return;armIdle()});
document.addEventListener('keydown',e=>{if(!root.hidden&&e.key==='Escape')close()});
new MutationObserver(()=>labels()).observe(document.documentElement,{attributes:true,attributeFilter:['lang']});

/* entry points: attract pill + buttons on the Moss Run result card */
function inject(){
  const pills=$('#s-attract .pills');
  if(pills&&!$('#sfPill')){
    const b=document.createElement('button');b.className='pill ghost';b.id='sfPill';b.textContent=t('pill');
    b.addEventListener('click',e=>{e.stopPropagation();open(null)});
    pills.appendChild(b);
  }
}
inject();
const end=$('#mrEnd');
if(end)new MutationObserver(()=>{
  const row=end.querySelector('.mr-btns');if(!row||row.querySelector('.sf-endbtn'))return;
  const txt=end.textContent||'';
  let score=null,target=null,m;
  if((m=txt.match(/(\d+)\s*(?:foglie su|of)\s*(\d+)/)))score=+m[1],target=+m[2];
  else if((m=txt.match(/Moss Run\s*·\s*(\d+)\/(\d+)/)))score=+m[1],target=+m[2];
  const b=document.createElement('button');b.className='mr-btn sf-endbtn';b.textContent=t('btn');
  b.onclick=()=>open({score,target});
  row.appendChild(b);
}).observe(end,{childList:true,subtree:true});
})();
